<section
  class="header-section header-section-visible"
  #header
  [ngClass]="{ 'closed-section': isClosed || !to.hasRepeatButtons }"
>
  <div class="page-header">
    <h3 class="page-title">
      {{ to?.label }}
    </h3>
    <div class="progress-bar-section">
      <div class="progress-bar-wrapper">
        <p *ngIf="!questionHovered?.flag" class="question-number">
          Question: {{ +questionNumber + 1 || 1 }}/{{ questionCount }}
        </p>
        <p *ngIf="questionHovered?.flag" class="question-number">
          {{ questionHovered?.questionToBeDisplayed }}
        </p>
        <div class="progress-bar-items">
          <span
            *ngFor="let question of visibleQuestions; let questionIndex = index"
            (mouseover)="progressBarHover(question.key, questionIndex)"
            (mouseout)="progressBarHoverOut()"
            (click)="progressBarClick(questionIndex, question.key)"
            class="bar"
            [ngClass]="{
              progress: ishighlightedProgressItem(questionIndex, question?.key),
              attended: isAttended(questionIndex, question?.key) && canNavigate(questionIndex),
              error: isError(questionIndex, question?.key),
              'pointer-none': questionCount === 1, 
              'cursor-pointer':canNavigate(questionIndex)
            }"
          >
        </span>
        </div>
      </div>
      <div class="progress-buttons">
        <span *ngIf="previousEnabled; else navDisabled" class="prevIcon-enable" (click)="previousQuestion()">
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="16" cy="16" r="16" fill="var(--prev-next-btn-color, transparent)"/>
            <path d="M16 0C24.8227 0 32 7.17731 32 16C32 24.8227 24.8227 32 16 32C7.17731 32 0 24.8227 0 16C0 7.17731 7.17731 0 16 0ZM11.0573 16.9427L17.724 23.6093C17.984 23.8693 18.3253 24 18.6667 24C19.008 24 19.3494 23.8693 19.6094 23.6093C20.1307 23.088 20.1307 22.2453 19.6094 21.724L13.8853 16L19.6093 10.276C20.1306 9.75469 20.1306 8.912 19.6093 8.39069C19.088 7.86938 18.2453 7.86938 17.724 8.39069L11.0573 15.0574C10.536 15.5787 10.536 16.4213 11.0573 16.9427Z" fill="var(--prev-next-btn-bg, #111111)"/>
          </svg>
        </span>
        <span *ngIf="nextEnabled; else navDisabled" (click)="nextQuestion()" class="nextIcon-enable">
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="16" cy="16" r="16" fill="var(--prev-next-btn-color, transparent)"/>
            <path d="M16 32C7.17731 32 0 24.8227 0 16C0 7.17731 7.17731 0 16 0C24.8227 0 32 7.17731 32 16C32 24.8227 24.8227 32 16 32ZM20.9427 15.0573L14.276 8.39069C14.016 8.13069 13.6747 8 13.3333 8C12.992 8 12.6506 8.13069 12.3906 8.39069C11.8693 8.912 11.8693 9.75469 12.3906 10.276L18.1147 16L12.3907 21.724C11.8694 22.2453 11.8694 23.088 12.3907 23.6093C12.912 24.1306 13.7547 24.1306 14.276 23.6093L20.9427 16.9426C21.464 16.4213 21.464 15.5787 20.9427 15.0573Z" fill="var(--prev-next-btn-bg, #111111)"/>
          </svg>
        </span>
        <ng-template #navDisabled>
          <span></span>
        </ng-template>
      </div>
    </div>
  </div>
</section>
<section
  class="form-section"
  [@QuestionAnimation]="questionAnimationState"
  (@QuestionAnimation.start)="animationStart()"
  (@QuestionAnimation.done)="animationDone()"
>
  <ng-container #fieldComponent></ng-container>
</section>
